module.exports = __webpack_public_path__ + "static/media/boat-canoe-dugout-svgrepo-com.dd5e51be.svg";